<template lang="pug">
  SingleLayout(
    :item='true'
  )
    template(
      slot='item'
    )
      AlbumEditor(
        v-if='album'
        ref='editor'
        :album='album'
        :directions='directions'
      )
</template>

<script>
import { mapGetters } from "vuex";

import l10n from "@/services/l10n";
import PageLoader from "@/services/pageLoader";
import errorHandler from "@/services/errorHandler";
import AlbumEditor from "@/components/Editor/AlbumEditor";
import singlePage from "@/mixins/pages/single.mixin";

const strategy = async function(route, ctx) {
  try {
    const id = PageLoader.getIdFromRoute(route);
    const { album = {} } = await PageLoader.getEditingAlbum({ id });

    ctx._album = album;
    ctx.albumId = id;

    route.meta.title = l10n("EDITING_ALBUM");
  } catch (error) {
    errorHandler.resolve(error);
  }

  try {
    if (ctx._album.active) {
      await PageLoader.getAlbumTracks({ id: ctx.albumId });
    } else {
      await PageLoader.getReviewTracks({ ids: ctx._album.tracks });
    }
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const { directions } = await PageLoader.getDirections();
    const genresIds = directions.reduce((genres, direction) => {
      return [...genres, ...direction.items];
    }, []);

    await PageLoader.getGenres({
      ids: genresIds
    });

    ctx.directions = directions;
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "AlbumEdit",
  data() {
    return {
      directions: [],
      albumId: null
    };
  },
  mixins: [singlePage(strategy)],
  computed: {
    ...mapGetters({
      albums: "albums/albums"
    }),
    album() {
      return this.albums[this.albumId];
    }
  },
  components: {
    AlbumEditor
  },
  async beforeRouteLeave(to, from, next) {
    window.onbeforeunload = null;

    const editor = this.$refs.editor;

    if (await editor.canLeavePage()) {
      return next();
    }

    return next(false);
  }
};
</script>
